import ContactForm from "@/components/form/contact-form/contact-form"
import EstimationForm from "@/components/form/estimation-form/estimation-form"

const FormBox = {
  components: {
    'contact-form': ContactForm,
    'estimation-form': EstimationForm
  },
  props: [
    'params'
  ],
  data () {
    return {
      pageIndex: 0
    }
  },
  methods: {
    handlePage(direction) {
      switch (direction) {
        case 'next':
          this.pageIndex += 1
          break
        case 'prev':
          this.pageIndex -= 1
          break
        default:
        // console.log("ERROR - no direction specified")
      }
    }
  },
  created () {
    bus.$on('form_box_switch_page', direction => {
      this.handlePage(direction)
    })
  },
}

export default FormBox
